<template>
  <div>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allClients"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="client" :rowKey="client.uuid">
          <a-switch
            :checked="handleCheck(client.resources)"
            @change="onChange(client.uuid, client.resources, ...arguments)"
            slot="actions"
          />
          <div class="container">
            <b>ID:</b>
            <span class="client-id disabled">{{ client.client_id }}</span>
            <a-icon
              type="copy"
              style="fontSize:20px;cursor: pointer; padding:5px;"
              v-clipboard:copy="client.client_id"
              @click="success"
            />
          </div>
          <a-list-item-meta class="clickable" :description="client.description">
            <a slot="title">
              <b>{{ client.client_name }}</b>
            </a>
            <a-avatar slot="avatar" shape="square" :size="48" :src="client.branding_options.logo" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      }
    };
  },

  computed: {
    allClients() {
      return this.$store.state.tenant.clients;
    }
  },

  components: {},

  methods: {
    async onChange(client, resources, checked) {
      let res = [];
      Object.assign(res, resources);
      if (checked == true) {
        res.indexOf(this.$route.params.uuid) === -1
          ? res.push(this.$route.params.uuid)
          : console.log("This item already exists");
      } else {
        res = res.filter(item => item !== this.$route.params.uuid);
      }
      try {
        this.loading = true;
        await this.$store.dispatch("tenant/patchItem", {
          endpoint: "clients",
          uuid: client,
          data: { resources: res }
        });
        await this.$store.dispatch("tenant/getItems", {
          endpoint: "clients"
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = true;
      }
    },
    success() {
      this.$message.success("Client id copied.", 5);
    },
    handleCheck(resources) {
      return resources.includes(this.$route.params.uuid);
    }
  },
  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "clients"
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.editable-add-btn {
  margin-bottom: 10px;
}
.client-id {
  display: inline-block;
  width: 300px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  padding: 5px;
  margin-left: 5px;
}

.disabled {
  opacity: 0.7;
}
</style>
